import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Loader } from "ui";

import { AiAssistant } from "../../aiAgents.types";
import { useGetAssistants, useUpdateAssistant } from "../../apis";
import { AgentCard } from "../../components/AgentCard";

import styles from "./AIAgents.module.scss";

const AIAgents = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { assistants, isLoading } = useGetAssistants();
  const updateMutation = useUpdateAssistant();

  const handleToggle = (assistant: AiAssistant, next: boolean) =>
    updateMutation.mutate({ assistantId: assistant.id, isActive: next });

  if (isLoading) {
    return (
      <div className={styles.loaderWrap}>
        <Loader />
      </div>
    );
  }

  return (
    <div className={styles.page}>
      <h1 className={styles.title}>{t("AI Agents")}</h1>

      <div className={styles.grid}>
        {assistants.map((assistant) => (
          <AgentCard
            key={assistant.id}
            assistant={assistant}
            toggleDisabled={updateMutation.isLoading}
            onClick={() => navigate(`/ai/agents/${assistant.id}`)}
            onToggleActive={(next) => handleToggle(assistant, next)}
          />
        ))}
      </div>
    </div>
  );
};

export default AIAgents;
